const toNormalized = (value) =>
  String(value || "")
    .trim()
    .toUpperCase();

const asNormalizedSet = (items) =>
  new Set((Array.isArray(items) ? items : []).map(toNormalized));

const NXMAP_MAPPABLE_DISCLOSURES_BY_FRAMEWORK = {
  "JJ-GROUP": asNormalizedSet([
    "GHG001",
    "GHG002",
    "GHG003",
    "GHG004",
    "GHG005",
    "GHG007",
    "GHG008",
    "GHG009",
    "GHG010",
    "GHG011",
    "GHG012",
    "GHG013",
    "GHG014",
    "GHG015",
    "GHG016",
    "GHG017",
    "GHG018",
    "GHG019",
    "GHG020",
    "GHG021",
    "GHG022",
  ]),
  SGX: asNormalizedSet(["SGX 101-1"]),
  BURSA: asNormalizedSet(["C11(a)", "C11(b)", "C11(c)"]),
  GRI: asNormalizedSet(["305-1", "305-2", "305-3"]),
  "IFRS-2": asNormalizedSet(["IFRS2E5(a)", "IFRS2E5(b)", "IFRS2E5(c)"]),
  "TG-BENCH": asNormalizedSet(["E002", "E003", "E004"]),
};

export const isNxmapMappableDisclosure = (framework, disclosureCode) => {
  const frameworkKey = toNormalized(framework);
  const disclosureKey = toNormalized(disclosureCode);
  if (!frameworkKey || !disclosureKey) return false;
  const mappedSet = NXMAP_MAPPABLE_DISCLOSURES_BY_FRAMEWORK[frameworkKey];
  if (!mappedSet) return false;
  return mappedSet.has(disclosureKey);
};
